module.exports = __webpack_public_path__ + "static/media/lv.4838077b.svg";